<div class="text-sm font-medium mt-1" [attr.data-testid]="testId()">
  @if (display(); as display) {
    @switch (display.kind) {
      @case (AnswerDisplayKind.ABSENT) {
        {{ 'common.noValue' | transloco }}
      }
      @case (AnswerDisplayKind.TWO_STAGE) {
        <span>{{ display.capabilityKey | transloco }}</span>
        <span class="text-gray-500"> · </span>
        <span>{{ display.provisioningKey | transloco }}</span>
        <span class="text-gray-500"> · </span>
        <span>{{ display.score | appNumber: '1.3-3' }}</span>
      }
      @case (AnswerDisplayKind.LABEL) {
        {{ display.labelKey | transloco }}
      }
      @default {
        {{ display.score | appNumber: '1.0-2' }}
      }
    }
  } @else {
    <span class="text-gray-500">{{ emptyKey() | transloco }}</span>
  }
</div>
